/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

export default function Profile() {
  const [user, setUser] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    supabase.auth.getUser().then(({ data: { user } }) => setUser(user));
  }, []);

  const handlePasswordChange = async () => {
    setError('');
    setMessage('');
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    if (newPassword.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password: newPassword });
    if (error) setError(error.message);
    else {
      setMessage('Password updated successfully.');
      setNewPassword('');
      setConfirmPassword('');
    }
    setLoading(false);
  };

  if (!user) return null;

  return (
    <div style={{ padding: '2rem', maxWidth: 600 }}>
      <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 24, color: '#111' }}>Profile</h2>

      <div style={{ background: '#fff', border: '1px solid #E0D8CF', borderRadius: 12, padding: '1.5rem', marginBottom: 20 }}>
        <div style={{ fontSize: 12, color: '#777', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12, fontWeight: 600 }}>Account Information</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f0ece6', fontSize: 14 }}>
          <span style={{ color: '#555' }}>Email</span>
          <span style={{ fontWeight: 500 }}>{user.email}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', fontSize: 14 }}>
          <span style={{ color: '#555' }}>Member since</span>
          <span style={{ fontWeight: 500 }}>{new Date(user.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
        </div>
      </div>

      <div style={{ background: '#fff', border: '1px solid #E0D8CF', borderRadius: 12, padding: '1.5rem' }}>
        <div style={{ fontSize: 12, color: '#777', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 16, fontWeight: 600 }}>Change Password</div>

        {error && (
          <div style={{ background: '#FDE8E8', color: '#9B2335', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 14 }}>
            {error}
          </div>
        )}
        {message && (
          <div style={{ background: '#E6F0EA', color: '#2D6A4F', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 14 }}>
            {message}
          </div>
        )}

        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 5 }}>New Password</label>
          <input
            type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)}
            placeholder="••••••••"
            style={{ width: '100%', padding: '9px 12px', border: '1px solid #E0D8CF', borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
          />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 5 }}>Confirm New Password</label>
          <input
            type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)}
            placeholder="••••••••"
            style={{ width: '100%', padding: '9px 12px', border: '1px solid #E0D8CF', borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
          />
        </div>

        <button
          onClick={handlePasswordChange} disabled={loading}
          style={{
            padding: '10px 24px', background: '#8B1E2D', color: '#fff',
            border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700,
            cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1
          }}
        >
          {loading ? 'Updating...' : 'Update Password'}
        </button>
      </div>
    </div>
  );
}